import React from 'react';
import cn from 'classnames';
import ReactMarkdown from 'react-markdown';
import rehypeRaw from 'rehype-raw';

import styles from './text.module.css';

const Text = ({ text, centered = false }) => (
  <div className={styles.text}>
    <ReactMarkdown
      className={cn('prose', { 'md:max-w-2xl md:m-auto': centered })}
      rehypePlugins={[rehypeRaw]}
    >
      {text}
    </ReactMarkdown>
  </div>
);

export default Text;
